const index = () => import(/* webpackChunkName: "marketing" */ '../views/marketing/index.vue')

export default [
  {
    path: 'marketing',
    name: 'marketing',
    meta: {
      parentsName: 'shop-site',
      name: '营销账号',
      keepAlive: true
    },
    component: index
  },
]
